import { z } from "zod";

export const COMPETENCIES_PAGE_SIZE = 25;

export interface CompetenciesFilters {
	status: "active" | "archived" | "any";
	companyWide?: boolean;
}

export const DEFAULT_FILTERS: CompetenciesFilters = { status: "active" };

/**
 * Internal form shape for the filter panel. `companyWide` is always a real boolean here
 * so TanStack form state is simple; on submit we only surface `companyWide: true` to
 * the external `CompetenciesFilters` shape (`false` is treated as "not applied").
 */
export const CompetenciesFilterFormSchema = z.object({
	status: z.enum(["active", "archived", "any"]),
	companyWide: z.boolean(),
});

export type CompetenciesFilterForm = z.infer<typeof CompetenciesFilterFormSchema>;

export const STATUS_OPTIONS: { value: CompetenciesFilters["status"]; label: string }[] = [
	{ value: "any", label: "Any" },
	{ value: "active", label: "Active" },
	{ value: "archived", label: "Archived" },
];

export const STATUS_LABELS = Object.fromEntries(STATUS_OPTIONS.map((o) => [o.value, o.label])) as Record<
	CompetenciesFilters["status"],
	string
>;
